import React, { useEffect,useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // File untuk styling
import Pagination from 'react-bootstrap/Pagination';
import { useNavigate } from 'react-router-dom';


function OrderListOperation() {
  const [tokenNow, setTokenNow] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState("");

    const [orders, setOrders] = useState([]);
    const [status, setStatus] = useState([]);
    const [types, setTypes] = useState([]);
    const [priority,  setPriority] = useState([]);
    const [selectedOption, setSelectedOption] = useState('keyOrderDate');

    // order date
    const [selectedOrderDateFrom, setSelectedOrderDateFrom] = useState('');
    const [inputOrderDateFrom, setInputOrderDateFrom] = useState('');
    const [selectedOrderDateUntil, setSelectedOrderDateUntil] = useState('');
    const [inputOrderDateUntil, setInputOrderDateUntil] = useState('');

    // status
    const [selectedStatus, setSelectedStatus] = useState('');
    const [inputStatus, setInputStatus] = useState('');

    // requestor PIC
    const [selectedRequestorPic, setSelectedRequestorPic] = useState('');
    const [inputRequestorPic, setInputRequestorPic] = useState('');

    // Destination Pic
    const [selectedDestinationPic, setSelectedDestinationPic] = useState('');
    const [inputDestinationPic, setInputDestinationPic] = useState('');

    // Requestor
    const [selectedRequestor, setSelectedRequestor] = useState('');
    const [inputRequestor, setInputRequestor] = useState('');

    // Destination
    const [selectedDestination, setSelectedDestination] = useState('');
    const [inputDestination, setInputDestination] = useState('');

    // Type
    const [selectedType, setSelectedType] = useState('');
    const [inputType, setInputType] = useState('');

    // Priority
    const [selectedPriority, setSelectedPriority] = useState("");
    const [inputPriority, setInputPriority] = useState("");

    // Id
    const [selectedId, setSelectedId] = useState('');
    const [inputId, setInputId] = useState('');

    const resource = "operation/order-list";
    const storedToken = localStorage.getItem('token');

    useEffect(() => {         
        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
      checkSessionToken();
      
      setTokenNow(storedToken);
      loadStatus();
      loadTypes();
      loadPriority();
      defaultPage(storedToken);
      }, []);

      function defaultPage(storedToken){
        // Mendapatkan tanggal hari ini
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const todayFormatted = tomorrow.toISOString().split('T')[0];

        // Mendapatkan tanggal 30 hari sebelum hari ini
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 30);
        const pastDateFormatted = pastDate.toISOString().split('T')[0];

        setInputOrderDateFrom(pastDateFormatted)
        setInputOrderDateUntil(todayFormatted)
        loadOrderList(selectedOption,pastDateFormatted,todayFormatted,storedToken);
        
      }

    useEffect(() => { 
        if (selectedStatus !== '') {
            loadOrderList(selectedOption, selectedStatus);
          } else if (selectedRequestorPic !== '') {
            loadOrderList(selectedOption, selectedRequestorPic);
          } else if (selectedDestinationPic !== '') {
            loadOrderList(selectedOption, selectedDestinationPic);
          } else if (selectedRequestor !== '') {
            loadOrderList(selectedOption, selectedRequestor);
          } else if (selectedDestination !== '') {
            loadOrderList(selectedOption, selectedDestination);
          } else if (selectedOrderDateFrom !== '' && selectedOrderDateUntil !== '') {
            loadOrderList(selectedOption,selectedOrderDateFrom,selectedOrderDateUntil);
          } else if (selectedType !== '') {
            loadOrderList(selectedOption, selectedType);
          } else if (selectedPriority !== "") {
            loadOrderList(selectedOption, selectedPriority);
          } else if (selectedId !== '' ) {
            loadOrderList(selectedOption,selectedId);
          }
    }, [selectedOrderDateFrom,selectedOrderDateUntil,selectedStatus, selectedRequestorPic,selectedDestinationPic,selectedRequestor,selectedDestination,selectedId,selectedType,selectedPriority,tokenNow]);
  
    const resetFiltersExcept = (filterType) => {
        if (filterType !== 'status') {
          setSelectedStatus('');
          setInputStatus('');
        }

        if (filterType !== 'requestorPic') {
          setSelectedRequestorPic('');
          setInputRequestorPic('');
        }

        if (filterType !== 'destinationPic') {
          setSelectedDestinationPic('');
          setInputDestinationPic('');
        }

        if (filterType !== 'requestor') {
          setSelectedRequestor('');
          setInputRequestor('');
        }

        if (filterType !== 'destination') {
          setSelectedDestination('');
          setInputDestination('');
        }

        if (filterType !== 'orderDate') {
          setSelectedOrderDateFrom('');
          setInputOrderDateFrom('');
          setSelectedOrderDateUntil('');
          setInputOrderDateUntil('');
        }

        if (filterType !== 'type') {
            setSelectedType('');
            setInputType('');
        }

        if (filterType !== "priority") {
            setSelectedPriority("");
            setInputPriority("");
        }

        if (filterType !== 'id') {
            setSelectedId('');
            setInputId('');
        }
      };
    
    const loadOrderList = async (key,value1,value2,token) => {
        try {   
          if(tokenNow !== "" && tokenNow !== null){
            const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-list?param1=${key}&param2=${value1}&param3=${value2}&token=${tokenNow}`);
            const data = result.data;
            setOrders(data);
          } else{
            const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-list?param1=${key}&param2=${value1}&param3=${value2}&token=${token}`);
            const data = result.data;
            setOrders(data);
          }
          // if(tokenNow !== "" && tokenNow !== null){
          //   const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-list?param1=${key}&param2=${value1}&param3=${value2}&token=${tokenNow}`, {
          //     headers: {
          //       authorization: 'random-string',
          //     },
          //   });
          //   const data = result.data;
          //   setOrders(data);
          // } else{
          //   const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-list?param1=${key}&param2=${value1}&param3=${value2}&token=${token}`, {
          //     headers: {
          //       authorization: 'random-string',
          //     },
          //   });
          //   const data = result.data;
          //   setOrders(data);
          // }
        } catch (error) {
          console.error("Error loading order list:", error);
        }
      };

    const loadStatus = async () => {
        const result = await axios.get("https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-status/find-all");
        const data = result.data.body;    
        setStatus(data);
      };

      const loadTypes = async () => {
        const result = await axios.get("https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-type/find-all"); 
        const data = result.data.body;    
        setTypes(data);
      };

      const loadPriority = async () => {
          const result = await axios.get(
            "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-priority/find-all"
          );
          const data = result.data.body;
          setPriority(data);
        };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
      };    

      const handleSelectChange = (event) => {
        setCurrentPage(1)
        setSelectedOption(event.target.value);
      };  

    //   order date
      const handleOrderDateFromChange = (event) => {
        setCurrentPage(1)
        setInputOrderDateFrom(event.target.value);
      };   
      const handleOrderDateUntilChange = (event) => {
        setCurrentPage(1)
        setInputOrderDateUntil(event.target.value);
      };

      // status
      const handleStatusChange = (event) => {
        setCurrentPage(1)
        setInputStatus(event.target.value);
      };

      // requestor PIC
      const handleRequestorPicChange = (event) => {
        setCurrentPage(1)
        setInputRequestorPic(event.target.value);
      };

      // destination PIC
      const handleDestinationPicChange = (event) => {
        setCurrentPage(1)
        setInputDestinationPic(event.target.value);
        };  

        // requestor
        const handleRequestorChange = (event) => {
          setCurrentPage(1)
        setInputRequestor(event.target.value);
        };

        // destination
        const handleDestinationChange = (event) => {
          setCurrentPage(1)
        setInputDestination(event.target.value);
        };

        // type
        const handleTypeChange = (event) => {
          setCurrentPage(1)
            setInputType(event.target.value);
            };

        // priority
        const handlePriortyChange = (event) => {
          setCurrentPage(1);
          setInputPriority(event.target.value);
        };
    
        // id
        const handleIdChange = (event) => {
          setCurrentPage(1)
            setInputId(event.target.value);
        };

      const handleSubmitStatus = (event) => {
        event.preventDefault();
        resetFiltersExcept('status')
        setSelectedStatus(inputStatus);
      };
    
      const handleSubmitRequestorPic = (event) => {
        event.preventDefault();
        resetFiltersExcept('requestorPic');
        setSelectedRequestorPic(inputRequestorPic);
      };

      const handleSubmitDestiantionPic = (event) => {
        event.preventDefault();
        resetFiltersExcept('destinationPic');
        setSelectedDestinationPic(inputDestinationPic);
      };
    
      const handleSubmitRequestor = (event) => {
        event.preventDefault();
        resetFiltersExcept('requestor');
        setSelectedRequestor(inputRequestor);
      };
      const handleSubmitDestination = (event) => {
        event.preventDefault();
        resetFiltersExcept('destination');
        setSelectedDestination(inputDestination);
      };
    
      const handleSubmitOrderDate = (event) => {
        event.preventDefault();
        resetFiltersExcept('orderDate');
        setSelectedOrderDateFrom(inputOrderDateFrom);
        setSelectedOrderDateUntil(inputOrderDateUntil);
      };

      const handleSubmitType = (event) => {
        event.preventDefault();
        resetFiltersExcept('type');
        setSelectedType(inputType);
      };

      const handleSubmitPriority = (event) => {
        event.preventDefault();
        resetFiltersExcept("priority");
        setSelectedPriority(inputPriority);
      };

      const handleSubmitId= (event) => {
        event.preventDefault();
        resetFiltersExcept('id');
        setSelectedId(inputId);
      };

      //pagination
      const [currentPage, setCurrentPage] = useState(1);
      const ordersPerPage = 25;
    
      // Get current orders
      const indexOfLastOrder = currentPage * ordersPerPage;
      const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
    
      // Change page
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      // Generate pagination items
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(orders.length / ordersPerPage); i++) {
        pageNumbers.push(i);
      }

      const renderPaginationItems = () => {
        const paginationItems = [];
        let ellipsisShown = false;
    
        for (let i = 1; i <= pageNumbers.length; i++) {
          if (i === 1 || i === pageNumbers.length || (i >= currentPage - 2 && i <= currentPage + 2)) {
            paginationItems.push(
              <Pagination.Item
                key={i}
                active={i === currentPage}
                onClick={() => paginate(i)}
              >
                {i}
              </Pagination.Item>
            );
            ellipsisShown = false;
          } else if (!ellipsisShown) {
            paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
            ellipsisShown = true;
          }
        }
    
        return paginationItems;
      };

    return (
        <div className="container-order-list">
          {/*<update-code */}
          <input type="hidden" name="token" value={tokenNow} /> {/* Hidden token field */}
            {/* update-code>*/}
            <h1>Cross Connect Order List</h1>
                <div className="title-order-input">   
                    <h6>Fulfill filter information to show order data.</h6>               
                    <h5>Filter</h5>
                </div>      
                <form>
                <div className="textbox-order-list">
                  <label htmlFor="comboBox">Key</label>
                  <select id="comboBox" name="options" onChange={handleSelectChange}>
                    <option value="keyOrderDate">Order Date</option>
                    <option value="keyPriority">Priority</option>
                    <option value="keyStatus">Status</option>
                    <option value="keyRequestor">Requestor</option>
                    <option value="keyDestination">Destination</option>
                    <option value="keyRequestorPic">Requestor PIC</option>
                    <option value="keyDestinationPic">Destination PIC</option>
                    <option value="keyCrossConnectType">Cross Connect Type</option>
                    <option value="keyId">Id</option>
                  </select>
                </div>               
                {selectedOption === 'key0'  && selectedOption !== 'keyStatus' && selectedOption !== 'keyRequestor' && selectedOption !== 'keyDestination' && selectedOption !== 'keyRequestorPic' && selectedOption !== 'keyDestinationPic' && selectedOption !== 'keyCrossConnectType' && selectedOption !== 'keyId' && (
                    <div className="value-order-list">
                        <div className="textbox-order-list">
                            <label htmlFor="Value">Value</label>
                            <input type="text" placeholder="Value" />
                        </div>
                        <input type="submit" className="btn-submit-order-list" value="Search" />
                    </div>
                )}
            </form>
            {selectedOption === 'keyOrderDate' && (
                <form onSubmit={handleSubmitOrderDate}>
                    <div className="textbox-order-list-date">
                        <label htmlFor="orderDate">Order Date</label>
                            <input type="date" 
                                className="dateFilter1"
                                id="orderDate" 
                                value={inputOrderDateFrom}
                                onChange={handleOrderDateFromChange}/>
                            <input type="date" 
                                className="dateFilter2"
                                id="orderDate" 
                                value={inputOrderDateUntil}
                                onChange={handleOrderDateUntilChange}/>                                           
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}       
            {selectedOption === 'keyRequestor' && (
                <form onSubmit={handleSubmitRequestor}>
                    <div className="textbox-order-list">
                        <label htmlFor="Requestor">Requestor</label>
                        <input type="text" 
                            placeholder="Requestor" 
                            value={inputRequestor}
                            onChange={handleRequestorChange}/>          
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}
            {selectedOption === 'keyDestination' && (
                <form onSubmit={handleSubmitDestination}>
                    <div className="textbox-order-list">
                        <label htmlFor="Destination">Destination</label>
                        <input type="text" 
                            placeholder="Destination" 
                            value={inputDestination}
                            onChange={handleDestinationChange}/>         
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}
            {selectedOption === 'keyRequestorPic' && (
                <form onSubmit={handleSubmitRequestorPic}>
                    <div className="textbox-order-list">
                        <label htmlFor="Requestor PIC">Requestor PIC</label>
                        <input type="text" 
                            placeholder="Requestor PIC" 
                            value={inputRequestorPic}
                            onChange={handleRequestorPicChange}/>    
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}
            {selectedOption === 'keyDestinationPic' && (
                <form onSubmit={handleSubmitDestiantionPic}>
                    <div className="textbox-order-list">
                        <label htmlFor="Destination PIC">Destination PIC</label>
                        <input type="text" 
                            placeholder="Destination PIC" 
                            value={inputDestinationPic}
                            onChange={handleDestinationPicChange}/>                        
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}
            {selectedOption === 'keyId' && (
                <form onSubmit={handleSubmitId}>
                    <div className="textbox-order-list">
                        <label htmlFor="Requestor PIC">Id</label>
                        <input type="number" 
                            placeholder="Id" 
                            value={inputId}
                            onChange={handleIdChange}/>                       
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}    
            {selectedOption === 'keyStatus' && (
                <form onSubmit={handleSubmitStatus}>
                    <div className="value-status">
                        <div className="textbox-order-list">
                            <label htmlFor="comboBox">Status</label>
                            <select id="comboBox" name="options" value={inputStatus} onChange={handleStatusChange}>
                                <option hidden>Select Order Status</option>
                                {status.map((item) => (
                                <option key={item.xcp_order_status_id} value={item.xcp_order_status_id}>
                                    {item.xcp_order_status_name}
                                </option>
                                ))}
                            </select>                         
                        </div>
                        <input type="submit" className="btn-submit-order-list" value="Search" />
                    </div>
                </form>
            )}    
            {selectedOption === 'keyCrossConnectType' && (
                <form onSubmit={handleSubmitType}>
                    <div className="value-type">
                        <div className="textbox-order-list">
                            <label htmlFor="comboBox">Cross Connect Type</label>
                            <select id="comboBox" name="options" value={inputType} onChange={handleTypeChange}>
                                <option hidden>Select Order Type</option>
                                {types.map((item) => (
                                <option key={item.xcp_order_type_id} value={item.xcp_order_type_id}>
                                    {item.xcp_order_type_name}
                                </option>
                                ))}
                            </select>                     
                        </div>
                        <input type="submit" className="btn-submit-order-list" value="Search" />
                    </div>
                </form>
            )}  
            {selectedOption === "keyPriority" && (
              <form onSubmit={handleSubmitPriority}>
                <div className="value-type">
                  <div className="textbox-order-list">
                    <label htmlFor="comboBox">Cross Connect Priority</label>
                    <select
                      id="comboBox"
                      name="options"
                      value={inputPriority}
                      onChange={handlePriortyChange}
                    >
                      <option hidden>Select Order Priority</option>
                      {priority.map((item) => (
                        <option
                          key={item.xcp_order_priority_id}
                          value={item.xcp_order_priority_id}
                        >
                          {item.xcp_order_priority_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="submit"
                    className="btn-submit-order-list"
                    value="Search"
                  />
                </div>
              </form>
            )}       
      <table className="table table-bordered">
        <thead>
          <tr>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Id</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Priority</th> 
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Order Date</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Cross Connect Type</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Requestor PIC</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Destination PIC</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Requestor</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Destination</th>        
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}}>Status</th>
            <th scope="col" style={{backgroundColor: '#070f26', color: 'white'}} colSpan="2">Action</th>
          </tr>
        </thead>
            <tbody>
            {currentOrders.map((order) => {
              const showManageOrderStatus =
              order.order_status_code === "XCPSTS-001" ||
              order.order_status_code === 'XCPSTS-098'||
              order.order_status_code === 'XCPSTS-099' ||              
              order.order_status_code === 'XCPSTS-100' ;
           
              const handleDisabledClick = (event) => {
                event.preventDefault();
              };

              return (
                <tr key={order.order_id}>
                <td>{order.order_id}</td>
                <td style={{backgroundColor: order.priority === 'Normal'? '#4dff88' : order.priority === 'High' ? '#ff4d4d' : 'transparent', color: 'black'}}>{order.priority}</td>
                <td>{formatDate(order.order_date)}</td>
                <td>{order.type}</td>
                <td>{order.pic_requestor}</td>
                <td>{order.pic_destination}</td>
                <td>{order.company_requestor}</td>
                <td>{order.company_destination}</td>
                <td>{order.status}</td>
                <td className="icon-center">
                    <Link to={`/order-detail?param1=${order.order_id}`}>
                    <i className="bi bi-eye-fill" title="Detail"></i>
                    </Link>
                </td>    
                <td className="icon-center">
                    <Link to={`/operation/manage-order-status?orderId=${order.order_id}`} onClick={showManageOrderStatus ? handleDisabledClick : undefined} className={showManageOrderStatus ? 'disabled-icon' : ''}>
                      <i className="bi bi-pencil-square" title="Manage Order Status"></i>
                    </Link>                
                  </td>       
                </tr>
            );
            })}
        </tbody>
      </table>

      <Pagination>
        <Pagination.First onClick={() => paginate(1)} />
        <Pagination.Prev
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
        />
        {renderPaginationItems()}
        <Pagination.Next
          onClick={() =>
            paginate(
              currentPage < pageNumbers.length ? currentPage + 1 : pageNumbers.length
            )
          }
        />
        <Pagination.Last onClick={() => paginate(pageNumbers.length)} />
      </Pagination>   
        </div>
    );
}

export default OrderListOperation;
